import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-update-modal',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './app-update.component.html',
  styleUrls: ['./app-update.component.scss'],
})
export class AppUpdateComponent {
  constructor(private modalCtrl: ModalController) {}

  install() {
    this.modalCtrl.dismiss('install');
  }

  later() {
    this.modalCtrl.dismiss('later');
  }
}
